import { MEASUREMENT_UNIT } from '@models/common.model'
import { LeakManagement } from '@models/leak.model'
import { LodashUtils } from '@utils/lodash'
import dayjs from 'dayjs'
import { Helpers } from './helper'

export const isValidDate = (dateStr) => {
  const parsed = Date.parse(dateStr)
  return (
    !LodashUtils.isNaN(parsed) && LodashUtils.isNumber(parsed) && parsed > 0
  )
}

export const isPastLeak = (meterAlert: LeakManagement.MeterAlert) =>
  !!isValidDate(meterAlert.alarmEndDate)

export const isLeakDetectedByMSW = (meterAlert: LeakManagement.MeterAlert) =>
  meterAlert.state === LeakManagement.METER_ALERT_STATE.VALID ||
  meterAlert.state === LeakManagement.METER_ALERT_STATE.INVALID ||
  meterAlert.state === LeakManagement.METER_ALERT_STATE.UNDEFINED

export const isLeakDetectedByUser = (meterAlert: LeakManagement.MeterAlert) =>
  !meterAlert.guid ||
  meterAlert.state === LeakManagement.METER_ALERT_STATE.REPORTED_VALID ||
  meterAlert.state === LeakManagement.METER_ALERT_STATE.REPORTED_INVALID

export const getLeakDuration = (startDate: Date, duration?: number) => {
  const now = new Date()
  const start = dayjs(startDate)
  const diff = Math.abs(start.diff(now, 'days'))
  const _duration = !LodashUtils.isNil(duration) ? Number(duration) : diff
  return `${_duration} ${_duration > 1 ? 'Days' : 'Day'}`
}

export const getTitle = (
  meterAlert: LeakManagement.MeterAlert,
  volume: string | number,
  unit: MEASUREMENT_UNIT,
) => {
  const start = dayjs(meterAlert.alarmStartDate)
  const dateFormatted = start.format('DD MMM YYYY')
  const durationStr = `${getLeakDuration(
    meterAlert.alarmStartDate,
    meterAlert.duration,
  )}`

  let newVolume = volume
  if (unit === MEASUREMENT_UNIT.LITRES) {
    const volumeToLitres = Helpers.toLitres(Number(volume))
    newVolume =
      volumeToLitres > 1000
        ? Helpers.abbrNumNotRound(volumeToLitres)
        : volumeToLitres.toString()
  }

  const leakVolumeStr = `${newVolume.toLocaleString()} ${Helpers.getMeasurementUnitLabel(
    unit,
  )}`

  const postfixByMSW = [dateFormatted, durationStr, leakVolumeStr].join(' | ')
  const postfixByUser = [dateFormatted, durationStr].join(' | ')

  const isReported = isLeakDetectedByUser(meterAlert)
  if (isPastLeak(meterAlert)) {
    return isReported ? postfixByUser : postfixByMSW
  }
  if (isLeakDetectedByMSW(meterAlert)) {
    return `Suspected Leak Detected | ${postfixByMSW}`
  }
  return `Reported Leak | ${postfixByUser}`
}

export const getLeakState = (
  isResolved: boolean,
  isDetectedByUser: boolean,
): LeakManagement.METER_ALERT_STATE => {
  if (isDetectedByUser) {
    return isResolved
      ? LeakManagement.METER_ALERT_STATE.REPORTED_VALID
      : LeakManagement.METER_ALERT_STATE.REPORTED_INVALID
  }
  return isResolved
    ? LeakManagement.METER_ALERT_STATE.VALID
    : LeakManagement.METER_ALERT_STATE.INVALID
}
